/**
 * Collection Manager Exception Queue API permissions (design §14).
 */

export const COLLECTION_MANAGER_EXCEPTION_QUEUE_READ_PERMISSION =
  'collection_manager_exception_queue:read' as const;

export const COLLECTION_MANAGER_EXCEPTION_QUEUE_PERMISSIONS = [
  COLLECTION_MANAGER_EXCEPTION_QUEUE_READ_PERMISSION,
] as const;

export type CollectionManagerExceptionQueuePermission =
  (typeof COLLECTION_MANAGER_EXCEPTION_QUEUE_PERMISSIONS)[number];

export function isCollectionManagerExceptionQueuePermission(
  permission: string
): permission is CollectionManagerExceptionQueuePermission {
  return (COLLECTION_MANAGER_EXCEPTION_QUEUE_PERMISSIONS as readonly string[]).includes(permission);
}
